// extracted by mini-css-extract-plugin
module.exports = {"subHeading":"Support_subHeading__SG2Kg","subSection":"Support_subSection__1Qz2k","underline":"Support_underline__1AAOa"};